(function () {
  'use strict';
  if (window.__ELIO_CART_DRAWER_GROUPS__) return;
  window.__ELIO_CART_DRAWER_GROUPS__ = true;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function sameVariant(item, variantId) {
    return String(item && (item.variant_id != null ? item.variant_id : item.id)) === String(variantId);
  }

  function buttonsFor(variantId) {
    return document.querySelectorAll('[data-elio-cart-group-action][data-variant-id="' + CSS.escape(String(variantId)) + '"]');
  }

  function setBusy(variantId, busy) {
    buttonsFor(variantId).forEach(function (btn) { btn.disabled = !!busy; });
  }

  function showError(variantId, message) {
    var box = document.querySelector('[data-elio-cart-group-error="' + CSS.escape(String(variantId)) + '"]');
    if (!box) return;
    var msg = box.querySelector('.elio-cart-group-error-message');
    if (msg) msg.textContent = message || 'Unable to update cart.';
    box.classList.remove('d-none-important');
  }

  async function getCart() {
    var response = await fetch(rootUrl() + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  async function addOneLike(line) {
    var item = {
      id: Number(line.variant_id != null ? line.variant_id : line.id),
      quantity: 1
    };
    if (line.properties && Object.keys(line.properties).length) item.properties = line.properties;
    var sellingPlan = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan && line.selling_plan_allocation.selling_plan.id;
    if (sellingPlan) item.selling_plan = sellingPlan;

    var response = await fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    });
    var data = await response.json();
    if (!response.ok || data.status || data.errors) throw new Error(data.description || data.message || data.errors || 'Unable to update cart');
    return data;
  }

  async function changeLine(key, quantity) {
    var response = await fetch(rootUrl() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: quantity })
    });
    var data = await response.json();
    if (!response.ok || data.status || data.errors) throw new Error(data.description || data.message || data.errors || 'Unable to update cart');
    return data;
  }

  async function removeLines(lines) {
    var updates = {};
    lines.forEach(function (line) { if (line && line.key) updates[String(line.key)] = 0; });
    var response = await fetch(rootUrl() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
    var data = await response.json();
    if (!response.ok || data.status || data.errors) throw new Error(data.description || data.message || data.errors || 'Unable to update cart');
    return data;
  }

  function requestNativeRefresh() {
    if (window.SHTHelper && typeof window.SHTHelper.forceUpdateCartStatus === 'function') {
      window.SHTHelper.forceUpdateCartStatus();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
  }

  async function handleGroupAction(button) {
    var action = button.getAttribute('data-elio-cart-group-action');
    var variantId = button.getAttribute('data-variant-id');
    if (!action || !variantId) return;

    setBusy(variantId, true);
    var safety = setTimeout(function () { setBusy(variantId, false); }, 1800);
    try {
      var cart = await getCart();
      var lines = (cart.items || []).filter(function (item) { return sameVariant(item, variantId); });
      if (!lines.length) {
        requestNativeRefresh();
        return;
      }

      if (action === 'plus') {
        await addOneLike(lines[0]);
      } else if (action === 'minus') {
        var minusLine = lines.slice().reverse().find(function (line) { return Number(line.quantity || 0) > 0; });
        if (minusLine) await changeLine(minusLine.key, Math.max(0, Number(minusLine.quantity || 0) - 1));
      } else if (action === 'remove') {
        await removeLines(lines);
      }

      requestNativeRefresh();
    } catch (error) {
      console.error('[ELIO cart groups]', error);
      showError(variantId, error && error.message ? error.message : 'Unable to update cart.');
    } finally {
      clearTimeout(safety);
      setTimeout(function () { setBusy(variantId, false); }, 900);
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-elio-cart-group-action]');
    if (!button || !button.closest('#cartDrawer')) return;
    event.preventDefault();
    event.stopPropagation();
    handleGroupAction(button);
  }, true);
})();
